<template>
  <v-row v-if="hasContent">
    <v-col cols="1" class="fournisseur text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="white" v-bind="attrs" v-on="on">{{ icone }}</v-icon>
        </template>
        <span data-testid="etiquette">{{ etiquette }}</span>
      </v-tooltip>
    </v-col>
    <v-col class="fournisseurlighten5">
      <span data-testid="texte">
        <a v-if="link" :href="linkWithProtocol">
          <slot></slot>
        </a>
        <span v-else>
          <slot></slot>
        </span>
      </span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FournisseurFicheInfo",
  props: {
    icone: {
      type: String,
      required: true,
    },
    etiquette: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasContent() {
      return (
        this.$slots.default &&
        (this.$slots.default.length > 1 ||
          this.$slots.default[0].text.trim() != "")
      );
    },
    linkWithProtocol() {
      const link = this.link;
      if (link.indexOf("@") != -1) {
        return "mailto://" + link;
      } else if (link.substring(0, 4).toLowerCase() == "http") {
        return link;
      } else {
        return "http://" + link;
      }
    },
  },
};
</script>

<style></style>
